import { Icon, type IconProps } from "./icon";

/** Back to the list. */
export function BackIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12.5 5l-5 5 5 5" />
    </Icon>
  );
}
